import styled from 'styled-components';
// import { rem } from 'polished';

interface IStyledModal {
  theme: any;
}

export const StyledModal = styled.div<IStyledModal>``;
